// Entry point, do not edit

import { initApp } from './app'
import packageJson from '../package.json';

localStorage.setItem('client-dashboard-version', packageJson.version)
initApp(document.getElementById('root'))
